import {
	Button,
	CardHeader,
	CardBody,
	FormGroup,
	Form,
	Input,
	InputGroupAddon,
	InputGroupText,
	InputGroup,
	Row,
	Col, Container,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import Authenticate from "lib/Core/Authenticate"
import React, {useRef, useState} from "react";
import Notify from "../../lib/Utils/Alert";
import {MotionCard} from "../../components/Core/MotionStrap";

const TradeInLogin = () =>
{
	const form = useRef();
	const notifRef = useRef();
	const [formState, setFormState] = useState("login");
	const authCtl = new Authenticate();

	function authenticate(e)
	{
		e.preventDefault();
		authCtl.login(form.current.username.value, form.current.password.value, !!form.current.new_password ? form.current.new_password.value : null).then(() =>
		{
			document.location.href = "/trade-in/start";
		}).catch(reason =>
		{
			if (reason.includes("NEW_PASSWORD"))
			{
				Notify(notifRef, "warning", "You must provide a new password for your account");
				setFormState("forcechange");
			} else
				Notify(notifRef, "danger", reason);
		});
	}

	function forgotPassword(e)
	{
		e.preventDefault();

		authCtl.forgotPassword(form.current.username.value).then(() =>
		{
			Notify(notifRef, "info", "An email was sent to your inbox with further instructions to recover your password");
		}).catch(reason =>
		{
			Notify(notifRef, "danger", reason);
		});
	}

	return (
		<Container id="hero" fluid={false}>
			<NotificationAlert ref={notifRef}/>
			<Row>
				<Col className="header py-7 py-lg-8">
					<Container>
						<div className="header-body text-center mb-7">
							<Row className="justify-content-center">
								<Col lg="5" md="6">
									<h1 className="text-black-50 text-danger" style={{textShadow:"4px 3px 5px rgba(0,0,0,0.3)"}}>Welcome back to Ncentiva Trade-in!</h1>
								</Col>
							</Row>
						</div>
					</Container>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col lg="5" md="7">
					<MotionCard initial={{scale: 0.2, opacity: 0.3, rotateZ: 75}} animate={{scale: 1, opacity: 1, rotateZ: 0, transition: {type: "spring"}}} className="bg-light shadow border-0">
						<CardHeader className="bg-danger text-center text-light py-3">
							Please enter your username and password
						</CardHeader>
						<CardBody className="px-lg-4 py-lg-4">
							<Form role="form" innerRef={form}>
								{formState === "forcechange" || formState === "login" ?
									<>
										<FormGroup className="mb-3">
											<InputGroup className="input-group-alternative">
												<InputGroupAddon addonType="prepend">
													<InputGroupText>
														<i className="fas fa-user"/>&nbsp;&nbsp;
													</InputGroupText>
												</InputGroupAddon>
												<Input placeholder="Username" type="email" name="username"/>
											</InputGroup>
										</FormGroup>
										<FormGroup>
											<InputGroup className="input-group-alternative">
												<InputGroupAddon addonType="prepend">
													<InputGroupText>
														<i className="fas fa-key"/>&nbsp;&nbsp;
													</InputGroupText>
												</InputGroupAddon>
												<Input placeholder="Password" type="password" name="password"/>
											</InputGroup>
										</FormGroup>
									</>
									: <></>}
								{formState === "forcechange" ?
									<FormGroup>
										<InputGroup className="input-group-alternative">
											<InputGroupAddon addonType="prepend">
												<InputGroupText>
													<i className="fas fa-key text-danger"/>&nbsp;&nbsp;
												</InputGroupText>
											</InputGroupAddon>
											<Input placeholder="New Password" type="password" name="new_password"/>
										</InputGroup>
									</FormGroup>
									: <></>}
								<div className="text-center">
									<Button type="submit" className="my-4" color="primary" onClick={authenticate}>
										Sign in
									</Button>
								</div>
							</Form>
						</CardBody>
					</MotionCard>
					<Row className="mt-3">
						<Col xs="12">
							<a className="text-dark" href="javascript(0);" onClick={forgotPassword}>
								<small>Forgot password?</small>
							</a>
						</Col>
					</Row>
				</Col>
			</Row>
		</Container>
	);
};

export default TradeInLogin;
